import React from 'react'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import PropTypes from 'prop-types'
import { Icon } from '@mui/material'
import { isElement, isNil } from 'lodash'

const ContextMenu = ({
    children,
    actions = [],
}) => {
    const [contextMenu, setContextMenu] = React.useState(null)

    const handleContextMenu = (event) => {
        event.stopPropagation()
        event.preventDefault()
        setContextMenu(
            contextMenu === null
                ? {
                    mouseX: event.clientX + 2,
                    mouseY: event.clientY - 6,
                }
                : // repeated contextmenu when it is already open closes it with Chrome 84 on Ubuntu
            // Other native context menus might behave different.
            // With this behavior we prevent contextmenu from the backdrop to re-locale existing context menus.
                null,
        )
    }

    const handleClose = (e) => {
        e.stopPropagation()
        setContextMenu(null)
    }

    return (
        <div onContextMenu={handleContextMenu} style={{ cursor: 'context-menu' }}>
            {children}
            <Menu
                open={contextMenu !== null}
                onClose={handleClose}
                anchorReference='anchorPosition'
                anchorPosition={
                    contextMenu !== null
                        ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                        : undefined
                }
                sx={{ zIndex: 10 }}
            >
                {actions.filter(a => isNil(a.displayed) || a.displayed).map((a, index) => (
                    <MenuItem
                        key={index}
                        onClick={e => {
                            e.preventDefault()
                            e.stopPropagation()
                            a.onClick()
                            handleClose(e)
                        }}
                        sx={{ zIndex: 10, display: 'flex', alignItems: 'center' }}
                    >
                        {a.icon && !isElement(a.icon) && <Icon sx={{ marginRight: '5px' }}>{a.icon}</Icon>}
                        {a.icon && isElement(a.icon) && a.icon}
                        {a.label}
                    </MenuItem>
                ))}
            </Menu>
        </div>
    )
}

ContextMenu.propTypes = {
    children: PropTypes.element.isRequired,
    actions: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        onClick: PropTypes.func.isRequired,
        icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
        displayed: PropTypes.bool,
    })).isRequired,
}

export default ContextMenu